// components/MaintenanceHeader.jsx
export default function MaintenanceHeader() {
  return (
      <h1 className="mb-0 text-danger">Site Maintenance</h1>
  );
}